module.exports = __webpack_public_path__ + "54f552cb252d8314df7780e881643c36.pdf";